import social1 from'./Images/css-3.png'
import social2 from'./Images/html-5.png'
import social3 from'./Images/js.png'
import social4 from'./Images/react.png'


export  const SocialData =[
    {
        id:1,
        image:social1,
},

{
id:2,
image:social2,
},
{
id:3,
image:social3,
},
{
id:4,
image:social4,
},
]
